export default {
  "clusteredColumnChart": {
    "config": {
      "changed": true,
      "title": "Clustered Column Chart",
      "navSection": "cart-line",
      "icon": "clusteredColumnChart",
      "image": "clusteredColumnChart.png"
    },
    "items": {
      "general": {
        "responsive": true
      },
      "legend": {
        "style": null,
        "circleDefaultIcon": null,
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#605E5C",
        "fontFamily": "Segoe UI",
        "fontSize": 8
      },
      "categoryAxis": {
        "position": "Left",
        "show": true,
        "axisType": "Continuous",
        "axisScale": "linear",
        "labelColor": "#605E5C",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "preferredCategoryWidth": 20,
        "maxMarginFactor": 25,
        "innerPadding": 20,
        "concatenateLabels": false,
        "showAxisTitle": true,
        "axisStyle": "showOnlyTitle",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 8,
        "titleFontFamily": "Segoe UI",
        "gridlineShow": false,
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "valueAxis": {
        "position": "Left",
        "gridlineShow": false,
        "show": true,
        "axisScale": "linear",
        "invertAxis": false,
        "labelColor": "#605E5C",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 10,
        "titleFontFamily": "Segoe UI Light",
        "gridlineColor": "#020f47",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#5e78e5"
      },
      "labels": {
        "color": "#666666",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "preserveWhitespace": true,
        "show": false,
        "labelOrientation": "horizontal",
        "labelPosition": "Auto",
        "labelOverflow": false,
        "labelDensity": 50,
        "backgroundColor": "#e6e6e6"
      },
      "plotArea": {
        "transparency": 100
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": true,
        "fontColor": "#020f47",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 10,
        "fontFamily": "Segoe UI Light"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": true,
        "type": "Report page",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 30,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "hundredPercentStackedBarChart": {
    "config": {
      "changed": false,
      "title": "100% Stacked Bar Chart",
      "navSection": "cart-line",
      "icon": "hundredPercentStackedBarChart",
      "image": "hundredPercentStackedBarChart.png"
    },
    "items": {
      "general": {
        "responsive": false
      },
      "legend": {
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#252423",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "categoryAxis": {
        "show": true,
        "position": "Right",
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      },
      "valueAxis": {
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": "01B8AA",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": "#252423",
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#448822"
      },
      "labels": {
        "show": true,
        "color": "#EEEEEE",
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Segoe UI",
        "enableBackground": true,
        "backgroundColor": "#ffffff",
        "backgroundTransparency": 30
      },
      "plotArea": {
        "transparency": 20
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "hundredPercentStackedColumnChart": {
    "config": {
      "changed": false,
      "title": "100% Stacked Column Chart",
      "navSection": "cart-line",
      "icon": "hundredPercentStackedColumnChart",
      "image": "hundredPercentStackedColumnChart.png"
    },
    "items": {
      "general": {
        "responsive": false
      },
      "legend": {
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#252423",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "categoryAxis": {
        "show": true,
        "position": "Right",
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      },
      "valueAxis": {
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": "01B8AA",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": "#252423",
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#448822"
      },
      "labels": {
        "show": true,
        "color": "#EEEEEE",
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "OutsideEnd",
        "fontSize": 11,
        "fontFamily": "Segoe UI",
        "enableBackground": true,
        "backgroundColor": "#ffffff",
        "backgroundTransparency": 30
      },
      "plotArea": {
        "transparency": 20
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "barChart": {
    "config": {
      "changed": true,
      "title": "Bar Chart (Stacked)",
      "navSection": "cart-line",
      "icon": "barChart",
      "image": "barChart.png"
    },
    "items": {
      "general": {
        "responsive": true
      },
      "legend": {
        "style": null,
        "circleDefaultIcon": null,
        "show": false,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#605E5C",
        "fontFamily": "Segoe UI",
        "fontSize": 8
      },
      "categoryAxis": {
        "position": "Left",
        "show": true,
        "axisType": "Continuous",
        "axisScale": "linear",
        "labelColor": "#666666",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "preferredCategoryWidth": 20,
        "maxMarginFactor": 25,
        "innerPadding": 35,
        "concatenateLabels": false,
        "showAxisTitle": false,
        "axisStyle": "showOnlyTitle",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 8,
        "titleFontFamily": "Segoe UI",
        "gridlineShow": false,
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "valueAxis": {
        "position": "Left",
        "gridlineShow": false,
        "show": true,
        "axisScale": "linear",
        "invertAxis": false,
        "labelColor": "#666666",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "showAxisTitle": false,
        "axisStyle": "showTitleOnly",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 8,
        "titleFontFamily": "DIN",
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#5e78e5"
      },
      "labels": {
        "color": "#666666",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "preserveWhitespace": true,
        "show": false,
        "labelOrientation": "horizontal",
        "labelPosition": "Auto",
        "labelOverflow": false,
        "labelDensity": 50,
        "backgroundColor": "#e6e6e6"
      },
      "totals": {
        "show": false,
        "color": "#605E5C",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "backgroundColor": "#252423",
        "showPositiveAndNegative": false
      },
      "plotArea": {
        "transparency": 100
      },
      "title": {
        "show": false,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "DIN"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": true,
        "type": "Default",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 0,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 14,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "columnChart": {
    "config": {
      "changed": true,
      "title": "Column Chart (Stacked)",
      "navSection": "cart-line",
      "icon": "columnChart",
      "image": "columnChart.png"
    },
    "items": {
      "general": {
        "responsive": true
      },
      "legend": {
        "style": null,
        "circleDefaultIcon": null,
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#605E5C",
        "fontFamily": "Segoe UI",
        "fontSize": 8
      },
      "categoryAxis": {
        "position": "Left",
        "show": true,
        "axisType": "Continuous",
        "axisScale": "linear",
        "labelColor": "#666666",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        // "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "preferredCategoryWidth": 20,
        "maxMarginFactor": 25,
        "innerPadding": 30,
        "concatenateLabels": false,
        "showAxisTitle": false,
        "axisStyle": "showOnlyTitle",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 9,
        "titleFontFamily": "DIN",
        "gridlineShow": false,
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "valueAxis": {
        "position": "Left",
        "gridlineShow": false,
        "show": true,
        "axisScale": "linear",
        "invertAxis": false,
        "labelColor": "#666666",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        // "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 9,
        "titleFontFamily": "Segoe UI",
        "gridlineColor": "#605e5c",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#5e78e5"
      },
      "labels": {
        "color": "#666666",
        // "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "preserveWhitespace": true,
        "show": false,
        "labelOrientation": "horizontal",
        "labelPosition": "Auto",
        "labelOverflow": false,
        "labelDensity": 50,
        "backgroundColor": "#e6e6e6"
      },
      "totals": {
        "show": false,
        "color": "#605E5C",
        // "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "backgroundColor": "#252423",
        "showPositiveAndNegative": false
      },
      "plotArea": {
        "transparency": 0
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "DIN"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": true,
        "type": "Report page",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 0,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 30,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "clusteredBarChart": {
    "config": {
      "changed": true,
      "title": "Clustered Bar Chart",
      "navSection": "cart-line",
      "icon": "clusteredBarChart",
      "image": "clusteredBarChart.png"
    },
    "items": {
      "general": {
        "responsive": true
      },
      "legend": {
        "style": null,
        "circleDefaultIcon": null,
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#605E5C",
        "fontFamily": "Segoe UI",
        "fontSize": 9
      },
      "categoryAxis": {
        "position": "Left",
        "show": true,
        "axisType": "Continuous",
        "axisScale": "linear",
        "labelColor": "#605E5C",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "preferredCategoryWidth": 20,
        "maxMarginFactor": 25,
        "innerPadding": 35,
        "concatenateLabels": false,
        "showAxisTitle": false,
        "axisStyle": "showOnlyTitle",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 10,
        "titleFontFamily": "Segoe UI Light",
        "gridlineShow": false,
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "valueAxis": {
        "position": "Left",
        "gridlineShow": false,
        "show": false,
        "axisScale": "linear",
        "invertAxis": false,
        "labelColor": "#605E5C",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "showAxisTitle": false,
        "axisStyle": "showTitleOnly",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 10,
        "titleFontFamily": "Segoe UI Light",
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#5e78e5"
      },
      "labels": {
        "color": "#666666",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "preserveWhitespace": true,
        "show": false,
        "labelOrientation": "horizontal",
        "labelPosition": "Auto",
        "labelOverflow": false,
        "labelDensity": 50,
        "backgroundColor": "#e6e6e6"
      },
      "plotArea": {
        "transparency": 100
      },
      "title": {
        "show": false,
        "text": "",
        "titleWrap": true,
        "fontColor": "#020f47",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 10,
        "fontFamily": "Segoe UI Light"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": true,
        "type": "Report page",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 30,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  }
}